<template>
  <div class="stepper">
    <View align="center" justify="space-between">
      <Text variant="h4">Step {{ activeStepIndex + 1 }} of {{ totalSteps }}</Text>
      <slot name="stepper-action-button"></slot>
    </View>

    <div class="step-indicators-wrapper">
      <div
        v-for="(step, index) in steps"
        :key="step"
        :class="{ inactive: index > activeStepIndex }"
        class="step-indicator"
        @click="emit('setStep', index)"
      ></div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import Text from './text.vue';
import View from './view/view.vue';

const props = defineProps<{ activeStepIndex: number; totalSteps: number }>();
const emit = defineEmits<{ setStep: [stepIndex: number] }>();

const steps = computed(() => Array(props.totalSteps));
</script>

<style scoped lang="scss">
.step-indicators-wrapper {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(0, 1fr));
  gap: var(--t-spacing-xs);

  .step-indicator {
    align-content: center;

    height: var(--t-spacing-md);
    cursor: pointer;

    &::after {
      content: '';

      display: block;
      width: 100%;
      height: 2px;

      border-radius: var(--t-border-radius-sm);
      background-color: var(--t-color-neutral-950);
    }

    &.inactive {
      cursor: default;

      &::after {
        background-color: var(--t-color-neutral-200);
      }
    }
  }
}
</style>
